<div class="body">
  <i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
  <div class="test">
    <div class="row column-one">
      <div class="content-wrapper">
        <div class="dialog-title">
          <img
            style="margin-right: 5px"
            width="24"
            height="24"
            src="/assets/img/icons/cyborg-premium.png"
          />
          HUNTER Premium
        </div>
        <p>
          Elevate your threat hunting workbench with access to exclusive content
          and capabilities available only with HUNTER Premium.
        </p>
        <ul>
          <li>
            Gain unrestricted access to Premium Hunt Packages for all security
            tools.
          </li>
          <li>
            Complete access to the hunt packages included in the Emerging
            Threats Collections.
          </li>
          <li>
            Direct line of communication with the Intel 471 Threat Hunt team via
            the Hunt Package Feedback Feature.
          </li>
          <li>
            Access to Threat Hunt Syncs with Intel 471 Threat Hunters as a part
            of the Customer Success Program.
          </li>
          <li>
            To plan, execute, report and manage the Hunt Packages, ask about
            access to the HUNTER Hunt Module.
          </li>
        </ul>
        <cyborg-button (click)="talkToCyborg()" color="primary">
          Talk to an Intel 471 Expert</cyborg-button
        >
      </div>
      <video
        loop
        controls
        oncanplay="this.play()"
        onloadedmetadata="this.muted = true"
      >
        <source
          src="https://go.intel471.com/hubfs/HUNTER%20Platform/Hunter%20Premium%20-%20Match%20Source%20-%202.mp4"
          type="video/mp4"
        />
      </video>
    </div>
  </div>
</div>
